@if (signedIn()) {
  <button type="button" class="help-button" aria-label="Help and feedback" (click)="open()">
    <tui-icon icon="@tui.circle-help" />
    @if (count() > 0) {
      <span class="dot" aria-hidden="true"></span>
    }
  </button>
}
